// Combined parser for the /documents route search params (#165). The other
// routes each delegate validateSearch to a single pure parseXSearch here; the
// documents route used to validate inline with unchecked `as` casts, which let
// a tampered `?source=foo` leak into typed search state. This composes the
// per-field parsers instead. `all` is the default for tab/source and is omitted
// from the URL, so the parsed shape carries only concrete, validated filters.

import { parseDocumentsSource } from './parse-documents-source.ts';
import { parseDocumentsTab } from './parse-documents-tab.ts';

export interface DocumentsSearch {
  // `all` is accepted on input (callers may navigate with the explicit default)
  // but the parser omits it from the returned shape so the URL stays clean.
  readonly tab?: 'all' | 'inbox' | 'assigned';
  readonly source?: 'manual_upload' | 'revolut_api' | 'email_inbox' | 'eigenbeleg';
  readonly selected?: string;
}

export function parseDocumentsSearch(input: Record<string, unknown>): DocumentsSearch {
  const tab = parseDocumentsTab(input.tab);
  const source = parseDocumentsSource(input.source);
  const selected =
    typeof input.selected === 'string' && input.selected.trim().length > 0
      ? input.selected
      : undefined;
  return {
    ...(tab !== 'all' ? { tab } : {}),
    ...(source !== 'all' ? { source } : {}),
    ...(selected !== undefined ? { selected } : {}),
  };
}
